module.exports = __webpack_public_path__ + "static/media/neveforesti.91c4d0a7.jpeg";